<template>
    <div>
        <slot name="label" :label="label">
            <label>{{ label }}</label>
        </slot>
        <slot name="value" :value="value">
            <p>{{ value || t('default::label.unknown') }}</p>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            required: true,
            validator: (prop) => typeof prop === 'string' || prop === null,
        },
    },
};
</script>
